import { theme } from '@chakra-ui/react';

const colors = {
    black: '#1A1A1A',
    white: '#FFFFFF',
    blue: {
        ...theme.colors.blue,
        50: '#E5F0FA',
        100: '#CCE2F6',
        200: '#99C5EC',
        400: '#006DD0',
        500: '#004D8C',
        900: '#003967',
    },
    gray: {
        ...theme.colors.gray,
        50: '#FAFAFA',
        100: '#EDF0F5',
        200: '#DEE4ED',
        300: '#C8C8CC',
        400: '#B4B9BF',
        500: '#91919A',
        600: '#646471',
        800: '#3D3D4E',
        900: '#333333',
    },
    green: {
        ...theme.colors.green,
        100: '#F3F9EC',
        200: '#E8F4D9',
        300: '#CDE5C3',
        500: '#8DC63F',
        900: '#5AB026',
        1000: '#2C6A04',
    },
    red: {
        ...theme.colors.red,
        200: '#FEF0EE',
        900: '#CC4646',
    },
    orange: {
        ...theme.colors.orange,
        200: '#FFE1CC',
        900: '#FF6700',
    },
    purple: {
        ...theme.colors.purple,
        200: '#E2D3EA',
        900: '#6F2396',
    },
};

export default colors;
